import type {
	Amenity,
	ExistingRoomEditDefault_EditPageQuery,
	RoomNewItem_EditPageQuery,
} from "@/lib/gql/__generated__/graphql";

import type { AutoGeneratorForFormModel } from "@/components/features/_model/types/auto-generator-for-form-model";

import type { FormOptionType } from "@/components/ui/form/_types/type";

import type { RoomInputZodSchemaType } from "./validation-schema";

const _excludeKeys = ["hotelPolicy", "reservationBasePolicy", "hotelID", "roomID"] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

export type ProductRoomFormModel = AutoGeneratorForFormModel<RoomInputZodSchemaType, ExcludeKeys, QueryData>;

export type QueryData = {
	hotelPolicy: {
		requiredPrepMillisecond: number;
		amenities: Amenity[];
	};
	connection: {
		planNameAndIDOptions: FormOptionType[];
	};
	discountList: ExistingRoomEditDefault_EditPageQuery["discountList"] | RoomNewItem_EditPageQuery["discountList"];
};
